import { useMemo, useEffect } from 'react';
import TypedField from '../TypedField';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

const getUnitLabel = (label, isSimpleOptions) => {
	return isSimpleOptions ? label + ' назад' : label;
};

const TypedFieldCTime = (props) => {
	const {
		isSimpleOptions,
		initialValue,
		value,
		onChange,
		errorMsg,
		setError,
		...rest
	} = props;

	const unitAutocomplete = useMemo(() => {
		const unitOptions = [
			{
				label: getUnitLabel('мин.', isSimpleOptions),
				value: 'minutes',
			},
			{
				label: getUnitLabel('ч.', isSimpleOptions),
				value: 'hours',
			},
			{
				label: getUnitLabel('дн.', isSimpleOptions),
				value: 'days',
			},
			{
				label: getUnitLabel('нед.', isSimpleOptions),
				value: 'weeks',
			},
		];

		const isoDuration = dayjs.duration(initialValue);
		const rawData = isoDuration.$d;
		const targetUnit = ['weeks', 'days', 'hours', 'minutes'].find(
			(unit) => rawData[unit] > 0,
		);
		const defaultValue = unitOptions.find(
			(option) => option.value === targetUnit,
		);

		return {
			disableClearable: true,
			defaultValue: defaultValue || unitOptions[0],
			options: unitOptions,
		};
	}, [initialValue, isSimpleOptions]);

	const validateValue = () => {
		// if (!value.unit || !value.text) return false;

		return true;
	};

	useEffect(() => {
		const isValid = validateValue();

		setError({
			isError: !isValid,
			message: isValid ? '' : 'Недопустимо',
		});
	}, [value.text, value.unit]);

	return (
		<TypedField
			typeWidth={184}
			autocomplete={unitAutocomplete}
			onChangeValue={onChange}
			value={value}
			textError={errorMsg}
			{...rest}
		/>
	);
};

TypedFieldCTime.propTypes = {
	...TypedField.propTypes,
	isSimpleOptions: PropTypes.bool,
	value: PropTypes.string,
	onChange: PropTypes.func,
	errorMsg: PropTypes.string,
	setError: PropTypes.func,
};

export default TypedFieldCTime;
